import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import dayjs from "dayjs";
import { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EmptyState from "../../../../../util/component/EmptyState";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useToggle from "../../../hooks/useToggle";
import GeneralInfoCard from "../generalInfo/GeneralInfoCard";
import SectionCardHeader from "../SectionCardHeader";
import DamageFormService from "../service/DamageFormService";
import { DamageFormTypes } from "../Types";
import ActionsCard from "./ActionsCard";
import Dialogs from "./dialogs";
import { ContextDamageForm } from "../DamageFormContext";
import { useHasScope } from "../../../../../config/globalConfig";

const Actions = () => {
  const hasScope = useHasScope;

  const { tenant, setLoading } = useContext(ContextOperation);
  const damageFormContext = useContext(ContextDamageForm);

  const t = useOperationTranslation();

  const { id } = useParams();

  const [openNewAction, toggleNewAction] = useToggle();

  const [actions, setActions] = useState<DamageFormTypes.IActions[]>([]);

  const getActions = () => {
    if (!id || !tenant) return;

    setLoading(true);
    DamageFormService.details.actions.get.byForm(tenant, parseInt(id)).then(
      (response) => {
        setLoading(false);
        setActions(response);
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  useEffect(() => {
    getActions();
  }, []);

  return (
    <>
      <Mui.Box mt={2}>
        <Mui.Card>
          <SectionCardHeader>
            <Mui.Grid container spacing={2} mr={1}>
              {hasScope("SCOPE_CREATE_DAMAGE_FORM_ACTION") && (
                <Mui.Grid item xs="auto">
                  <Mui.Button
                    variant="outlined"
                    size="small"
                    startIcon={<MuiIcons.Email />}
                    onClick={toggleNewAction}
                  >
                    <Mui.Typography color="inherit" variant="h6">
                      {t("damageForm.details.action.title")}
                    </Mui.Typography>
                  </Mui.Button>
                </Mui.Grid>
              )}
            </Mui.Grid>
          </SectionCardHeader>

          <Mui.CardContent>
            <GeneralInfoCard />
          </Mui.CardContent>
        </Mui.Card>

        {actions.map((element) => {
          return (
            <ActionsCard
              date={dayjs(element.creationDateTime).format("DD/MM/YYYY HH:mm")}
              user={element.creationUser}
              message={element.message}
            />
          );
        })}

        {actions.length === 0 ? (
          <Mui.Box mt={3}>
            <EmptyState
              title={t("damageForm.details.action.emptyState.title")}
              content={t("damageForm.details.action.emptyState.content1")}
            />
            <EmptyState
              title=""
              content={t("damageForm.details.action.emptyState.content2")}
            />
            <EmptyState
              title=""
              content={t("damageForm.details.action.emptyState.content3")}
            />
          </Mui.Box>
        ) : null}
      </Mui.Box>

      <Dialogs.NewAction
        open={openNewAction}
        onClose={toggleNewAction}
        updateActions={getActions}
      />
    </>
  );
};
export default Actions;
